<script setup lang="ts">
import { computed } from 'vue'

import { classMerge } from '../utils'

const props = withDefaults(defineProps<{
  twClass?: string;
  baseurl: string;
  currentPage: number;
  pageNumber: number;
}>(), {
  twClass: '',
  baseurl: '',
  currentPage: 1,
  pageNumber: 1
})

const baseStyle = `inline-flex justify-center items-center font-button focus-visible:outline-none
                   focus-visible:ring focus-visible:ring-offset-1 ring-ring text-button-md gap-1.5
                   normal h-action-lg w-action-lg`
const primaryStyle = `bg-action text-action-foreground border-2 border-action-stroke
                      rounded-action-primary hover:bg-action-hover hover:text-action-hover-foreground
                      hover:border-action-hover-stroke focus:bg-action-focus focus:text-action-focus-foreground
                      focus:border-action-focus-stroke`
const ghostStyle = `text-action-ghost-foreground rounded-action-ghost
                    hover:text-action-ghost-hover-foreground focus:text-action-ghost-hover-foreground`

const href = computed(() => {
  const { currentPage, pageNumber, baseurl } = props
  if (currentPage === pageNumber) {
    return undefined
  }
  if (pageNumber === 1) {
    return baseurl
  }
  return `${baseurl}?page=${pageNumber}`
})

</script>

<template>
  <a :href="href"
     :class="classMerge([baseStyle,
                         currentPage === pageNumber ? primaryStyle : ghostStyle,
                         {'pointer-events-none': currentPage === pageNumber}, twClass])">
    {{ pageNumber }}
  </a>
</template>
